import { PayloadAction } from "@reduxjs/toolkit";
import { Page } from "../../../../../common/models/Page";
import { ServiceState } from "../models/ServiceState";

const setPageServices = (state: ServiceState, action: PayloadAction<Page>) => {
    state.page = action.payload.page;
}

export default setPageServices;